import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class CampSiege2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.CAMP_SIEGE2;
}

export default CampSiege2PoiTileEntity;
